import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set. " +
      "Copy .env.example to .env.local and fill them in.",
  );
}

export const supabase: SupabaseClient<Database> = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Implicit flow (tokens land in the URL hash: #access_token=...) so
    // magic links work when the parent opens the email in a different
    // browser or device from where they requested it. PKCE was more
    // secure but required the code-verifier to be present in the same
    // browser's localStorage — parents opening links from Gmail/Outlook
    // apps landed in a different browser and the exchange failed
    // silently, producing the "flicker back to login" bug.
    flowType: "implicit",
  },
  global: {
    headers: {
      "x-client-info": "expression-swimmers-web",
    },
  },
});
